import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/yimo-img/chatRoom.png'
import _imports_1 from '../../assets/img/yimo-img/accompany.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-05d9e17f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-bg" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "chatRoom",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "accompanyWord",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "scrollbottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_footer_c = _resolveComponent("footer-c")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["box2 animate__faster", { animate__animated: _ctx.nowPage === 5, animate__fadeInLeft: _ctx.nowPage === 5 }])
      }, _hoisted_3, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["box3 animate__faster", {
        animate__animated: _ctx.nowPage === 5,
        animate__fadeInRight: _ctx.nowPage === 5
      }])
      }, [
        _hoisted_4,
        _createElementVNode("div", {
          class: _normalizeClass(["pageFourWord", {
          animate__animated: _ctx.nowPage === 5,
          animate__fadeInRight: _ctx.nowPage === 5
        }])
        }, [
          _createTextVNode(" 汇集来自世界各地的电竞玩家，趣事轶事多"),
          _hoisted_5,
          _createTextVNode("与世界分享你的激情和技艺，发现新的游戏伙伴和朋友！ ")
        ], 2)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_footer_c)
    ])
  ], 64))
}